import { NextContentfulImage } from "@components/Image";
import LinkCopiedBadge from "@components/LinkCopiedBadge/LinkCopiedBadge";
import { useSettings } from "@utilities/context/settings";
import { useEffect, useState } from "react";
import ShareSvg from "../../public/image/svg/share.svg";

export const SocialShare = ({ url }) => {
  const [open, setOpen] = useState(false);

  const { siteSettings } = useSettings();

  const replace = (shareLink) =>
    shareLink?.replace("%URL%", encodeURIComponent(url));
  const [copied, setCopied] = useState(false);
  const [copyPing, setCopyPing] = useState(0);
  useEffect(() => {
    setCopied(false);
  }, [open]);

  useEffect(() => {
    if (!copied) return;
    const id = window.setTimeout(() => setCopied(false), 3000);
    return () => window.clearTimeout(id);
  }, [copyPing, copied]);

  return (
    <div className={`social-share ${open && "show"}`}>
      <button
        className="share-toggle rounded-full"
        aria-label="Share content"
        onClick={(e) => {
          e.preventDefault();
          setOpen(!open);
        }}
      >
        <span className="visually-hidden">Share</span>
        <i className="icon-share" data-grunticon-embed="data-grunticon-embed">
          <ShareSvg />
        </i>
      </button>
      <ul className="share-links">
        {siteSettings?.globalSocialShareCollection.map(
          ({ fields: { name: _name, darkIcon, shareLink } }, index) => {
            const name = _name || darkIcon.name;
            return (
              <li key={`${name}${index}`}>
                {shareLink === "COPY" ? (
                  <>
                    <button
                      type="button"
                      aria-label={`${name} - Copied Link to Clipboard`}
                      rel="noreferrer"
                      onClick={() => {
                        navigator.clipboard.writeText(url);
                        setCopied(true);
                        setCopyPing((p) => p + 1);
                      }}
                    >
                      <NextContentfulImage
                        src={darkIcon.url}
                        alt={name}
                        width={30}
                        height={30}
                      />
                    </button>
                    <LinkCopiedBadge show={copied} />
                  </>
                ) : (
                  <a
                    aria-label={`${name} - Opens a new window`}
                    href={replace(shareLink)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <NextContentfulImage
                      src={darkIcon.url}
                      alt={name}
                      width={30}
                      height={30}
                    />
                  </a>
                )}
              </li>
            );
          }
        )}
      </ul>
    </div>
  );
};

export default SocialShare;
